export function toEntityId(value: unknown): string | null {
    return typeof value === "string" || typeof value === "number" ? String(value) : null;
}

export function toEntityIds(value: { id?: string | number | null }[] | undefined | null): string[] {
    return (value ?? []).flatMap(item => toEntityId(item.id) ?? []);
}
